module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"gps_fix_interval":"GPS Fix Interval"},"de":{"gps_fix_interval":"GPS Fix Intervall"},"fr":{"gps_fix_interval":"GPS Intervalle fixe"},"it":{"gps_fix_interval":"Intervallo di GPS"}}')
  delete Component.options._Ctor
}
